import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RouterContent from './RouterContent';
import { AppStatusProvider } from '../context/AppStatusContext';
import { AppSettingsGetter } from '../context/AppSettingsContext';
import { useAppSettingsStateStore } from '../context/AppSettingsStateContext';
import { ShoresideInstructionGetter } from '../context/ShoresideInstructionContext';
import { TooltipGetter } from '../context/TooltipContext';
import { ApiEndpointsGetter, getApiEndpointsData } from '../context/ApiEndpointsContext';
import { initStores } from 'src/api/offline/offlineApi';
import { errorLoggingService } from '../services/errorLoggingService';

const AppRouter = () => {
    const { isGettingAppSettings, isGettingApiEndpoints, setGettingAppSettings, setIsGettingApiEndpoints } = useAppSettingsStateStore();

    useEffect(() => {
        const fetchData = async () => {
            setGettingAppSettings(true);
            setIsGettingApiEndpoints(true);

            const appSettings = await new AppSettingsGetter().getAppSettings();
            setGettingAppSettings(false);

            await new ApiEndpointsGetter().getApiEndpoints(appSettings);
            setIsGettingApiEndpoints(false);

            // Initialize error logging now that settings and endpoints are available
            const endpoints = getApiEndpointsData();
            const logEndpoint = endpoints?.['logBrowserError'];
            if (logEndpoint?.url) {
                errorLoggingService.initialize(appSettings.api, logEndpoint.url, appSettings.releaseId || '');
            }

            await new ShoresideInstructionGetter().getShoresideInstruction();
            await new TooltipGetter().getTooltip();

            initStores();
        };

        fetchData();
    }, []);

    return (
        <Router>
            {!isGettingAppSettings && !isGettingApiEndpoints && (
                <AppStatusProvider>
                    <RouterContent />
                </AppStatusProvider>
            )}
        </Router>
    );
};

export default AppRouter;
